const EditorErrorMessage = ({ message }: { message: string }) => {
  return (
    <span
      className="text-can-midnight-steel self-start rounded-sm bg-red-100 px-2"
      role="alert"
    >
      {message}
    </span>
  );
};

export { EditorErrorMessage };
